import React from 'react';
import { FieldMetaState } from 'react-final-form';

// NOTE: These helper functions are copy-pasted from `components/BillPay/Shared/Utils/FormUtils`
export const getErrorMessage = (
  { touched, error = [] }: FieldMetaState<unknown>,
  helperText?: React.ReactNode | null
) => {
  const [errorMessage] = error;

  return (touched && errorMessage) || helperText;
};

export const hasError = ({ touched, error }: FieldMetaState<unknown>) => {
  return Boolean(touched && error);
};
